// Create a new file: src/components/SubscriptionModal.jsx
import React from "react";
import { useTranslation } from "react-i18next";
import ReferralRazorPay from "./ReferralRazorPay"; // Adjust path as needed

const SubscriptionModal = ({ isOpen, onClose, onSubscribe, userData }) => {
  const { t } = useTranslation();
  
  if (!isOpen) return null;
  
  return (
    <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{t("Subscription Expiring Soon")}</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <p>{t("Your membership will expire on March 31st. Please renew your subscription to continue accessing the portal.")}</p>
            <div className="d-grid gap-2">
              <ReferralRazorPay 
                userEmail={userData?.email} 
                userName={userData?.name}
                onSuccess={onSubscribe}
                buttonText={t("Subscribe Now")}
                amount={100000} // ₹1000.00 in paise
              />
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              {t("Remind Me Later")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionModal;